import useMediaQuery from "./useMediaQuery";

export const useMediaQueries = () => {
  const mq1536 = useMediaQuery("(max-width: 1536px)");
  const mq1440 = useMediaQuery("(max-width: 1440px)");
  const mq1366 = useMediaQuery("(max-width: 1366px)");
  const mq1280 = useMediaQuery("(max-width: 1280px)");
  const mq1024 = useMediaQuery("(max-width: 1024px)");
  const mq820 = useMediaQuery("(max-width: 820px)");
  const mq768 = useMediaQuery("(max-width: 768px)");
  const mq430 = useMediaQuery("(max-width: 430)");

  return { mq1536, mq1440, mq1366, mq1280, mq1024, mq820, mq768, mq430 };
};
